import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Tab, TabStrip2 } from '../common/TabStrip'
import { ToggleSwitch } from '../common/ToggleSwitch'
import { EditConstraints } from '../optimize/EditConstraints'
import { EditSliderConstraints } from '../optimize/EditSliderConstraints'
import { ProductBlock } from '../product-drawer/ProductBlock'
import { EditAreaAtts2 } from './EditAreaAtts2'
import { EditAreaSliders } from './EditAreaSliders'
import './ScenarioEditor.scss'
import { ScenarioSummary } from './ScenarioSummary'
import { actionCreators as configActionCreators } from '../../store/Config.ts'
import { actionCreators as selectionsActionCreators } from '../../store/Selections.ts'

export const ScenarioEditor = (props) => {
  const dispatch = useDispatch()
  
  const state = useSelector(state => state)
  const study = useSelector(state => state.study)
  const selections = useSelector(state => state.selections)
  const model = useSelector(state => state?.model)
  const activeModel = props?.activeModel || model?.modelNames?.[0]

  const dirty = model[activeModel]?.config?.dirty
  console.log('state', state);
  console.log('model', model);

  const [selectedTabValue, setSelectedTabValue] = useState('product')
  const [summaryChangesOnly, setSummaryChangesOnly] = useState(true)

  useEffect(() => {
    console.log('Updated selections:', selections)
  }, [selections, dirty])

  if (!model[activeModel]?.config || !selections) return null

  const config = model[activeModel]?.config

  const style = props?.style
  const format = props?.format || 'config'
  const studyId = study.uid
  const beqLevel = config?.brandEquitiesDef?.level || 'product'

  const selectedProduct = config?.play?.find(p => p.uid === selections.product?.uid) || {}
  const available = selectedProduct ? selectedProduct.available : false

  //const productSelected = selections?.product
  const beqSelection = selections[beqLevel]
  const summarySelectedItem = selections.product

  const selTabIndex = ['product', 'price', 'message', 'brand', 'summary'].indexOf(selectedTabValue)

  // const selectProduct = () => {
  //   console.log('selectedProduct', selectedProduct);
  //   console.log('selectedProduct', selectedProduct);
  //   window.topBar.openProducts(selectedProduct, 
  //                 sel => {
  //                   dispatch(selectionsActionCreators.setSelection('product', sel))
  //                   window.topBar.hideMenu()
  //                 },
  //                 { allow: ['product'], multiSelect: false }
  //               )
  // }
  
  
  //use a custom forecast component here?
   const forecast = async () => {
  
      let selfilter = datasetFilter// filter.selectedFilter
      await dispatch(fordForecastActionCreators.ford_forecast(selfilter, null, props.filtersDatasetId, activeConfig))
  }
  


  return (
    <div className="scenario-editor" style={style}>
      <div className="tab-section">
        <div style={{ marginBottom: 5 }}>
          <span style={{width:'100%'}} className={'btn sel' + (!dirty ? ' disabled' : '')} onClick={props.forecastFunction}> 
            Apply changes & compute
          </span>
        </div>

        <TabStrip2 selectedIndex={selTabIndex} selectedIndexChanged={(selectedTabIndex, selectedTabValue) => setSelectedTabValue(selectedTabValue)}>
          <Tab value='product'>Product</Tab>
          <Tab value='price'>Price</Tab>
          <Tab value='message'>Message</Tab>
          <Tab value='brand'>Brand</Tab>
          {format !== 'optimizer' ? <Tab value='summary'>Summary</Tab> : <i/>}
        </TabStrip2>
      </div>

      {format !== 'optimizer' && (
        selectedTabValue === 'product' || selectedTabValue === 'price' ?
          <div className="product-selector">
            <ProductBlock studyId={studyId} {...selectedProduct}
              available={available}
              standalone={true}
              productsOnly={true}
              dirty={config?.dirty}
              allow={['product']}
              style={{ width: '100%' }}
              onClick={() => 
                window.topBar.openProducts(selectedProduct, 
                sel => { 
                  console.log('User selected:', sel) // Debugging
                  dispatch(selectionsActionCreators.setSelection('product', sel)) 
                  window.topBar.hideMenu() 
                }, 
                { allow: ['product'], multiSelect: false } 
              )
            }
            />
          </div>
        : selectedTabValue === 'message' || selectedTabValue === 'brand' ?
          <div className="product-selector">
            <ProductBlock studyId={studyId} {...beqSelection}
              standalone={true}
              allow={[beqLevel]}
              style={{ width: '100%' }}
              onClick={() => 
                window.topBar.openProducts(beqSelection, 
                  sel => {
                    dispatch(selectionsActionCreators.setSelection(beqLevel, sel))
                    window.topBar.hideMenu()
                  },
                  { allow: [beqLevel] }
                )
              }
            />
          </div>
        : selectedTabValue === 'summary' ?
          <div className="product-selector">
            <ToggleSwitch className='mini' 
              on={summaryChangesOnly}
              onChange={newVal => setSummaryChangesOnly(newVal)}
            >
              Show Changes Only
            </ToggleSwitch>
            
            {!summaryChangesOnly &&
              <ProductBlock studyId={studyId} {...summarySelectedItem}
                standalone={true}
                allow={[selections.hierarchy]}
                style={{ width: '100%', marginTop: 10 }}
                onClick={() => 
                  window.topBar.openProducts(beqSelection, 
                    sel => {
                      dispatch(selectionsActionCreators.set('summarySelectedItem', sel))
                      window.topBar.hideMenu()
                    },
                    { allow: [selections.hierarchy] }
                  )
                }
              />
            }
          </div>
        : null
      )}

      {format === 'optimizer' ? (
        <div className="editor-content">
          {selectedTabValue === 'product' && <EditConstraints/>}
          {selectedTabValue === 'price' && <EditConstraints area="price"/>}
          {selectedTabValue === 'message' && <EditSliderConstraints area="message"/>}
          {selectedTabValue === 'brand' && <EditSliderConstraints area="brand"/>}
        </div>
      ) : (
        <div className="editor-content">
          {selectedTabValue === 'product' && <EditAreaAtts2 prodId={(selectedProduct || {}).uid} key={(selectedProduct || {}).uid} configModel={activeModel} monitor_atts={[]} />}
          {selectedTabValue === 'price' && <EditAreaAtts2 area="price" prodId={(selectedProduct || {}).uid} key={(selectedProduct || {}).uid} configModel={activeModel} monitor_atts={[]}/>}
          {selectedTabValue === 'message' && <EditAreaSliders area="message" selection={(beqSelection || {})?.uid} selectionLabel={(beqSelection || {})?.label}/>}
          {selectedTabValue === 'brand' && <EditAreaSliders area="brand" selection={(beqSelection || {}).uid} selectionLabel={(beqSelection || {})?.label}/>}
          {selectedTabValue === 'summary' && <ScenarioSummary filter={summarySelectedItem} changesOnly={summaryChangesOnly} />}
        </div>
      )}
    </div>
  )
}


